import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import blackLocation from './images/black-location-marker.png';
// import futsalImage from './images/futsal-ai.jpeg'; // Import your image
import './Map.css';
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Custom Marker Icon
const customIcon = new L.Icon({
  iconUrl: blackLocation,
  iconSize: [32, 32],
  iconAnchor: [16, 45],
  popupAnchor: [0, -45],
});

const formatUrl = (court) => {
  const getValue = (addressField, rootField) => {
    return (addressField || rootField || "").toLowerCase().replace(/\s+/g, "-");
  };

  const country = getValue(court.address?.country, court.country);
  const state = getValue(court.address?.state, court.state);
  const city = getValue(court.address?.city, court.city);
  const slug = court.slug;

  let url = `/courts`;

  if (country) url += `/${country}`;
  if (state) url += `/${state}`;
  if (city) url += `/${city}`;
  if (slug) url += `/${slug}`;

  return url;
};

function Map({ courts }) {

  const navigate = useNavigate();

  const defaultCenter = courts.length > 0 ? courts[0].coordinates : [51.505, -0.09];

  return (
    <MapContainer center={defaultCenter} zoom={13} style={{ height: "500px", width: "100%" }}>
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />
      <Recenter center={defaultCenter} />
      {courts.map((court, index) => (
        <Marker key={index} position={court.coordinates} icon={customIcon}>
          <Popup>
            <div className="popup-content">
              {/* <strong>
                {court.name}
              </strong> */}
              <h3
                className="popup-court-item-title"
                onClick={() => navigate(formatUrl(court))}
                onMouseEnter={(e) => e.target.classList.add("hover")}
                onMouseLeave={(e) => e.target.classList.remove("hover")}
              >
                {court.name}
              </h3>
              {/* <em>{court}</em> */}
              {/* <div className="popup-image-container">
                <img
                  src={futsalImage}
                  alt={`${court.name} - ${court.type}`}
                  className="popup-image"
                />
              </div> */}
            </div>
          </Popup>
        </Marker>
      ))}
    </MapContainer>
  );
}

// Component to dynamically recenter the map when `center` changes
function Recenter({ center }) {
  const map = useMap();
  useEffect(() => {
    map.setView(center);
  }, [center, map]);
  return null;
}

export default Map;